import {updateAutoAdd, list} from "@/services/api/app/google/seat-management/shared-drive/backupSettings";

const defaultState = () => ({
  autoAdd: {
    sharedDrives: true,
  },
});

export default {
  namespaced: true,

  actions: {
    list({commit}) {
      return list()
        .then((data) => {
          if (data?.autoAdd) {
            commit('setAutoAdd', data.autoAdd)
          }
        })
    },
    updateAutoAdd({commit}, data) {
      return updateAutoAdd(data)
        .then(({autoAdd}) => {
          commit('setAutoAdd', autoAdd)
        })
    },
  },

  mutations: {
    setAutoAdd(state, autoAdd) {
      state.autoAdd = autoAdd
    },
  },


  getters: {
    //seatType: SharedDrive
    getAutoAddSettingByType: (state) => (seatType) => {
      return state.autoAdd && state.autoAdd[seatType];
    },
  },

  state: defaultState
}
